import React, { useState, useEffect } from "react";
import { useQuery } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import ScoreHorizontal from 'components/common/ScoreHorizontal'
import Loader from 'components/general/Loader'
import SportCode from "components/common/SportCode";
import PageHeader from "components/common/PageHeader";
import NotAvailable from "components/common/NotAvailable";
import { CompetitionFromStore, findArray } from "helpers/utils";
import { useViewport } from 'components/general/useViewPort';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isLiveStatus } from "helpers/status";

import {
  faStop, faCircle, faCaretUp, faPlus, faMinus,
} from "@fortawesome/free-solid-svg-icons";
import {
  RESULT_STATUS,
  getResultStatusAsInteger,
  isStartListStatus,
  isFinishedStatus
} from "helpers/status";

// Results
import BkgIndividual from 'components/sports/bkg/views/BkgIndividual'
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import BkgReferees from "components/sports/bkg/views/BkgReferees";

const BkgContext = () => {
  const { mirs_rsc, mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport()
  const [openESL, setOpenESL] = useState(false);

  // results data
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
      queryFn: getResultRSC_H2H,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //enabled: !!confCategory
      onError: (error) =>
        console.error(`Something went wrong: ${error.message}`),
    });

  if (isError) { return <NotAvailable /> }
  if (isLoading) { return <Loader /> }
  if (!data?.results) { return <NotAvailable /> }

  let score;
  let votesRed = findArray(findArray(data?.results?.items, { startSortOrder: [1] }).extendedResults, { er_code: ['VOTES'] }).er_value;
  let votesBlue = findArray(findArray(data?.results?.items, { startSortOrder: [2] }).extendedResults, { er_code: ['VOTES'] }).er_value;


  let topBodyLabel

  if (isLiveStatus(data?.results?.status?.code)) {
    let period = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'PERIOD')?.ei_value;
    topBodyLabel = <SportCode discipline={mirs_discipline} entity='@Period' code={period} />
  }

  let homeColor = 'red';
  let awayColor = 'blue';
  let isTeam = findArray(data?.results?.items, { startSortOrder: [1] })?.participant?.__typename === 'Person' ? true : false;

  let statusMatch = data?.results?.status.code
  let botBodyLabel

  if (getResultStatusAsInteger(statusMatch) === RESULT_STATUS.LIVE || getResultStatusAsInteger(statusMatch) === RESULT_STATUS.START_LIST || (isFinishedStatus(statusMatch))) {
    if (breakPoint === "sm" || breakPoint === "xs") {
      botBodyLabel = (
        <div className="flex-column d-flex w-45">
          <div className="d-flex content-center">
            <div className='score-horizontal-extra-information-box'>
              <Label data={'LabelBkgVotes'} />:
            </div>
            <div className='score-horizontal-extra-information-box w-20'>
              {votesRed && <>{'('+votesRed+')'}</>}
            </div>
            <div className='score-horizontal-extra-information-box'>
              {votesBlue && <>{'('+votesBlue+')'}</>}
            </div>
          </div>
        </div>
      )
    } else {
      botBodyLabel = (
        <div className="flex-column d-flex w-20">
          <div className="d-flex content-center">
            <div className='score-horizontal-extra-information-box'>
              <h5><strong><Label data={'LabelBkgVotes'} />:</strong></h5>
            </div>
            <div className='score-horizontal-extra-information-box w-30'>
              {votesRed && <h5><strong>({votesRed})</strong></h5>}
            </div>
            <div className='score-horizontal-extra-information-box'>
              {votesBlue && <h5><strong>({votesBlue})</strong></h5>}
            </div>
          </div>
        </div>
      )
    }
  }

  let home = findArray(data?.results?.items, { startSortOrder: [1] });
  let away = findArray(data?.results?.items, { startSortOrder: [2] });
  let extendedStartList;

  if (home?.extCompetitor || away?.extCompetitor || home?.teamAthletes?.extCompetitor || away?.teamAthletes?.extCompetitor) {
    extendedStartList = <div id='extended-start-list'>
      {home?.extCompetitor ? <div className="mb-2">{home?.extCompetitor}</div> : ''}
      {away?.extCompetitor ? <div>{away?.extCompetitor}</div> : ''}
      {home?.teamAthletes?.extCompetitor ? <div>{home?.teamAthletes?.extCompetitor}</div> : ''}
      {away?.teamAthletes?.extCompetitor ? <div>{away?.teamAthletes?.extCompetitor}</div> : ''}
    </div>
  } else {
    extendedStartList = '';
  }

  score = <ScoreHorizontal
    data={data}
    homeUniform={isTeam ? homeColor : ''}
    awayUniform={isTeam ? awayColor : ''}
    scoreBody={{
      top: topBodyLabel,
      bottom: botBodyLabel
    }}
    scoreFooter={{
      top: extendedStartList &&
        <div className="w-100 d-flex justify-content-end">
          <div>
            <Button variant="outline-secondary" onClick={() => setOpenESL(!openESL)} aria-controls='extended-start-list' aria-expanded={openESL}>
              <FontAwesomeIcon icon={openESL ? faMinus : faPlus} />
            </Button>
          </div>
        </div>,
      bottom: openESL && extendedStartList
    }}
  />

  const isKra = CompetitionFromStore() === 'EG2023';

  return (
    <>
      <PageHeader data={data} />
      <div className='mirs-page-container'>
      <div className='my-5'>
        {score}
      </div>
      {!isKra && <BkgIndividual data={data} /> }
      <BkgReferees data={data} />
      </div>
    </>
  );
};

export default BkgContext;
